import { render } from "./NewsButton.vue?vue&type=template&id=1b0bf7f4&scoped=true"
import script from "./NewsButton.vue?vue&type=script&lang=js"
export * from "./NewsButton.vue?vue&type=script&lang=js"

import "./NewsButton.vue?vue&type=style&index=0&id=1b0bf7f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b0bf7f4"]])

export default __exports__